import api from './api';

export const paymentService = {
  // Mevcut ayın ödeme durumunu getir
  getCurrentMonthPaymentStatus: async () => {
    try {
      const response = await api.get(`/api/business/payments/current-month-status`);
      return response.data;
    } catch (error) {
      console.error('Mevcut ay ödeme durumu getirilirken hata:', error);
      throw error;
    }
  },

  // İşletmenin ödeme geçmişini getir
  getMyPayments: async (params) => {
    try {
      const response = await api.get(`/api/business/payments/my-payments`, { params });
      return response.data;
    } catch (error) {
      console.error('Ödeme geçmişi getirilirken hata:', error);
      throw error;
    }
  },

  // Ödeme istatistiklerini getir
  getPaymentStats: async () => {
    try {
      const response = await api.get(`/api/business/payments/stats`);
      return response.data;
    } catch (error) {
      console.error('Ödeme istatistikleri getirilirken hata:', error);
      throw error;
    }
  },

  // Belirli bir ödemeyi getir
  getPaymentById: async (paymentId) => {
    try {
      const response = await api.get(`/api/business/payments/${paymentId}`);
      return response.data;
    } catch (error) {
      console.error('Ödeme bilgisi getirilirken hata:', error);
      throw error;
    }
  },

  // Kart kaydetme/güncelleme
  savePaymentCard: async (cardData) => {
    try {
      const response = await api.post('/api/business/payments/save-card', cardData);
      return response.data;
    } catch (error) {
      console.error('Kart kaydedilirken hata:', error);
      throw error;
    }
  },
};
